export const engagementCampaignsCarouselSlidesForCampaign = "/engagement/campaigns/carousel_slides_for_campaign";
